import { render, staticRenderFns } from "./Uspto.vue?vue&type=template&id=3aab2b5d&scoped=true&"
import script from "./Uspto.vue?vue&type=script&lang=js&"
export * from "./Uspto.vue?vue&type=script&lang=js&"
import style0 from "./Uspto.vue?vue&type=style&index=0&id=3aab2b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab2b5d",
  null
  
)

export default component.exports